/**
 * PermaShine Landing — vanilla JS module.
 * No framework, no compile step. Just a few targeted enhancements over the
 * server-rendered HTML in templates/page.permashine.liquid.
 */
(function () {
  'use strict';

  var CONFIG = window.PERMASHINE_CONFIG || { variants: {} };
  var VARIANTS = CONFIG.variants || {};
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  // ============================================================
  // VARIANT SELECTION + QUANTITY + ADD-TO-CART
  // ============================================================
  (function buyLogic() {
    var currentVariant = 'single';
    var currentQty     = 1;
    var adding         = false;

    function fmt(n) { return '$' + n.toFixed(2); }

    function updateVariantUI(id) {
      var v = VARIANTS[id];
      if (!v) return;
      currentVariant = id;

      // Toggle .active class on variant rows.
      $$('[data-variant]').forEach(function (el) {
        el.classList.toggle('active', el.getAttribute('data-variant') === id);
      });

      // Swap big product image, buybox thumb, sticky thumb.
      function swap(sel, attrKey) {
        $$(sel).forEach(function (img) {
          var url = img.getAttribute('data-' + (id === 'kit' ? 'kit' : 'bottle'));
          if (url && img.getAttribute('src') !== url) img.setAttribute('src', url);
          if (img.hasAttribute('alt')) img.setAttribute('alt', v.name);
        });
      }
      swap('[data-product-image]');
      swap('[data-product-thumb]');
      swap('[data-sticky-thumb]');

      // Sticky text.
      $$('[data-sticky-name]').forEach(function (el) { el.textContent = v.name; });
      $$('[data-sticky-price]').forEach(function (el) { el.textContent = fmt(v.price); });
      $$('[data-sticky-was]').forEach(function (el) {
        if (v.was) {
          el.textContent = fmt(v.was);
          el.style.display = '';
        } else {
          el.textContent = '';
          el.style.display = 'none';
        }
      });

      updateButtonPrice();
    }

    function updateButtonPrice() {
      var v = VARIANTS[currentVariant];
      if (!v) return;
      var total = v.price * currentQty;
      $$('[data-button-price]').forEach(function (el) { el.textContent = fmt(total); });
    }

    // Variant row clicks.
    $$('[data-variant]').forEach(function (el) {
      el.addEventListener('click', function () {
        updateVariantUI(el.getAttribute('data-variant'));
      });
    });

    // Quantity +/-.
    $$('[data-qty-delta]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = +btn.getAttribute('data-qty-delta');
        currentQty = Math.max(1, currentQty + delta);
        $$('[data-qty-val]').forEach(function (el) { el.textContent = currentQty; });
        updateButtonPrice();
      });
    });

    // Add to Cart (every [data-add-to-cart] button).
    $$('[data-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (adding) return;

        var override = btn.getAttribute('data-cart-variant');
        var id       = override || currentVariant;
        var v        = VARIANTS[id];
        if (!v) return;
        var qty = override ? 1 : currentQty;

        // Meta Pixel AddToCart.
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'AddToCart', {
            content_ids: [v.shopifyId || id],
            content_name: v.name,
            content_type: 'product',
            value: v.price * qty,
            currency: 'USD',
            num_items: qty
          });
        }

        if (!v.shopifyId) {
          console.warn('[PermaShine] No Shopify variant ID for ' + id);
          return;
        }

        // If the bundle button forced a specific variant, also surface that
        // selection in the buybox so the UI feels consistent.
        if (override) updateVariantUI(override);

        adding = true;
        var originalLabel = btn.innerHTML;
        $$('[data-add-to-cart]').forEach(function (b) { b.disabled = true; });
        btn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.shopifyId, quantity: qty }] })
        })
          .then(function (r) {
            if (!r.ok) return r.text().then(function (t) { throw new Error(t || ('HTTP ' + r.status)); });
            return r.json();
          })
          .then(function () {
            return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            // Update any cart-count bubble selectors the theme might use.
            $$('.cart_count, [data-cart-count], [data-permashine-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            if (typeof window.PERMASHINE_UPDATE_BUBBLE === 'function') window.PERMASHINE_UPDATE_BUBBLE(cart.item_count);

            // Dispatch the standard cart events that themes / apps listen for.
            var detail = { cart: cart, source: 'permashine-landing' };
            ['cart:item-added','cart:refresh','cart:updated','cart:change'].forEach(function (name) {
              document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
            });
            if (typeof window.publish === 'function') {
              window.publish('cart-update', detail);
              if (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
                window.publish(window.PUB_SUB_EVENTS.cartUpdate, detail);
              }
            }

            // Brief "Added ✓" feedback, then restore.
            btn.textContent = 'Added ✓';
            setTimeout(function () {
              btn.innerHTML = originalLabel;
              updateButtonPrice();
              $$('[data-add-to-cart]').forEach(function (b) { b.disabled = false; });
              adding = false;
            }, 1600);
          })
          .catch(function (err) {
            console.error('[PermaShine] Add to cart failed:', err);
            btn.innerHTML = originalLabel;
            updateButtonPrice();
            $$('[data-add-to-cart]').forEach(function (b) { b.disabled = false; });
            adding = false;
            alert('Something went wrong adding to cart. Please try again.');
          });
      });
    });

    // Initial state.
    updateVariantUI('single');
  })();

  // ============================================================
  // PHOTO REVIEW CAROUSEL — dot indicators (built dynamically),
  // click-to-scroll, and active-state synced via IntersectionObserver.
  // ============================================================
  (function reviewCarousel() {
    var carousel = document.querySelector('[data-review-carousel]');
    var dotsHost = document.querySelector('[data-review-dots]');
    if (!carousel || !dotsHost) return;
    var cards = $$('.review-card', carousel);
    if (!cards.length) return;

    function scrollCardIntoView(card) {
      var carouselRect = carousel.getBoundingClientRect();
      var cardRect = card.getBoundingClientRect();
      var offsetWithin = (cardRect.left - carouselRect.left) + carousel.scrollLeft;
      var target = offsetWithin - (carouselRect.width / 2) + (cardRect.width / 2);
      carousel.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }

    var dots = cards.map(function (card, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'review-carousel-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'View review ' + (i + 1));
      dot.addEventListener('click', function () { scrollCardIntoView(card); });
      dotsHost.appendChild(dot);
      return dot;
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        // The card with the largest intersection ratio wins the active state.
        var best = null, bestRatio = 0;
        entries.forEach(function (e) {
          if (e.intersectionRatio > bestRatio) { bestRatio = e.intersectionRatio; best = e.target; }
        });
        if (best) {
          var idx = cards.indexOf(best);
          if (idx !== -1) {
            for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('active', i === idx);
          }
        }
      }, { root: carousel, threshold: [0.5, 0.75, 0.95] });
      cards.forEach(function (c) { io.observe(c); });
    }
  })();

  // ============================================================
  // FAQ ACCORDION
  // ============================================================
  $$('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      if (!item) return;
      var willOpen = !item.classList.contains('open');
      $$('.faq-item.open').forEach(function (o) { o.classList.remove('open'); });
      if (willOpen) item.classList.add('open');
    });
  });

  // ============================================================
  // VARIANT SELECTOR — single buy box with 3 selectable rows. Clicking a
  // row swaps the selected variant; the single CTA's data-cart-variant +
  // displayed price update so the existing add-to-cart handler picks up
  // the right variant on click.
  // ============================================================
  (function variantSelector() {
    var rows = $$('[data-variant-row]');
    if (!rows.length) return;
    var cta = document.querySelector('[data-variant-cta]');
    if (!cta) return;
    var card = document.querySelector('.variant-selector-card');
    var priceSpan = cta.querySelector('[data-cta-price]');
    var previewImg = document.querySelector('[data-variant-preview]');

    function selectRow(row) {
      if (row.classList.contains('variant-row-soldout')) return;
      rows.forEach(function (r) { r.classList.remove('active'); });
      row.classList.add('active');
      var input = row.querySelector('input[type="radio"]');
      if (input) input.checked = true;
      var variant    = row.getAttribute('data-cart-variant');
      var price      = row.getAttribute('data-price') || '';
      var previewUrl = row.getAttribute('data-preview');
      var previewAlt = row.getAttribute('data-preview-alt');
      if (variant) {
        cta.setAttribute('data-cart-variant', variant);
        // Drives the CSS for the banner + kit-contents bullets + preview border.
        if (card) card.setAttribute('data-active-variant', variant);
      }
      if (priceSpan && price) priceSpan.textContent = price;
      if (previewImg && previewUrl && previewImg.getAttribute('src') !== previewUrl) {
        previewImg.setAttribute('src', previewUrl);
        if (previewAlt) previewImg.setAttribute('alt', previewAlt);
      }
    }

    rows.forEach(function (row) {
      row.addEventListener('click', function () { selectRow(row); });
    });
  })();

  // ============================================================
  // STICKY MOBILE "ORDER NOW" PILL — visible when neither the hero
  // nor the #buy section is intersecting the viewport.
  // ============================================================
  (function stickyOrder() {
    var pill = document.querySelector('[data-sticky-order]');
    if (!pill) return;
    var hero = document.querySelector('.hero');
    var buy  = document.getElementById('buy');
    if (!('IntersectionObserver' in window)) {
      // Fallback: show after a small scroll if IntersectionObserver missing.
      window.addEventListener('scroll', function () {
        pill.classList.toggle('show', window.scrollY > 600);
      }, { passive: true });
      return;
    }
    var state = { hero: !!hero, buy: false };
    function update() {
      pill.classList.toggle('show', !state.hero && !state.buy);
    }
    var heroObs = new IntersectionObserver(function (entries) {
      state.hero = entries[0].isIntersecting; update();
    }, { threshold: 0 });
    var buyObs = new IntersectionObserver(function (entries) {
      state.buy = entries[0].isIntersecting; update();
    }, { threshold: 0 });
    if (hero) heroObs.observe(hero);
    if (buy)  buyObs.observe(buy);
    update();
  })();

  // ============================================================
  // SMOOTH-SCROLL BUTTONS (Shop Now / Shop PermaShine →)
  // ============================================================
  $$('[data-scroll-to]').forEach(function (el) {
    el.addEventListener('click', function () {
      var t = document.getElementById(el.getAttribute('data-scroll-to'));
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // ============================================================
  // EVERGREEN COUNTDOWN BAR — counts down to midnight local time
  // for the visitor's browser. Rolls over automatically each night.
  // Multiple [data-countdown] instances on the page stay in sync.
  // ============================================================
  (function countdown() {
    var bars = $$('[data-countdown]');
    if (!bars.length) return;
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    function nextLocalMidnight() {
      var now = new Date();
      // 00:00:00.000 of the day AFTER today in the client's local timezone.
      return new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1,
        0, 0, 0, 0
      ).getTime();
    }
    function tick() {
      var diff = nextLocalMidnight() - Date.now();
      if (diff < 0) diff = 0;
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      bars.forEach(function (bar) {
        var nd = bar.querySelector('[data-cd-d]');
        var nh = bar.querySelector('[data-cd-h]');
        var nm = bar.querySelector('[data-cd-m]');
        var ns = bar.querySelector('[data-cd-s]');
        if (nd) nd.textContent = pad(d);
        if (nh) nh.textContent = pad(h);
        if (nm) nm.textContent = pad(m);
        if (ns) ns.textContent = pad(sec);
      });
    }
    tick();
    setInterval(tick, 1000);
  })();

  // ============================================================
  // "Why It Works" looping fake-GIF videos — pause off-screen ones
  // so we don't burn CPU decoding 3 video streams nobody can see.
  // Autoplay + loop is set in HTML; we just toggle play()/pause().
  // ============================================================
  (function whyVideos() {
    var vids = $$('.why-media video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.play().catch(function () {});
        } else {
          e.target.pause();
        }
      });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { io.observe(v); });
  })();

  // ============================================================
  // LAZY VIDEO METADATA — fetch the first frame for the poster only
  // when the card scrolls near the viewport. Keeps initial payload tiny
  // while still showing a real preview (instead of a black box) on mobile.
  // ============================================================
  (function lazyVideos() {
    var videos = $$('.ugc-video-card video');
    if (!videos.length) return;
    var loadOne = function (v) {
      // Add a #t=0.1 fragment so the displayed frame is at 0.1s once metadata
      // arrives — avoids a potentially black 0-th frame on some encodings.
      var src = v.getAttribute('src') || '';
      if (src && src.indexOf('#t=') === -1) v.setAttribute('src', src + '#t=0.1');
      v.preload = 'metadata';
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            loadOne(e.target);
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '300px 0px' });
      videos.forEach(function (v) { io.observe(v); });
    } else {
      // Fallback: just load all if no IO support.
      videos.forEach(loadOne);
    }
  })();

  // ============================================================
  // Meta Pixel ViewContent (page-load tracking)
  // ============================================================
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'ViewContent', {
      content_name: 'PermaShine Landing Page',
      content_category: 'Tire Coating',
      content_type: 'product',
      currency: 'USD'
    });
  }
})();
